// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aspect-ratio-box {
  width: 100%;
  position: relative;
  height: auto;
  display: block;
  padding-bottom: 75%;
  box-sizing: border-box;
}
.aspect-ratio-box[class*="--standard"] {
  padding-bottom: 75%;
}
.aspect-ratio-box[class*="--square"] {
  padding-bottom: 100%;
}
.aspect-ratio-box[class*="--wide"] {
  padding-bottom: 56.25%;
}
.aspect-ratio-box[class*="--portrait"] {
  padding-bottom: 133.3333333333%;
}
.aspect-ratio-box[class*="--semiportrait"] {
  padding-bottom: 116.6666666667%;
}
.aspect-ratio-box .image {
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  color: transparent;
  padding: 0;
}

@media (min-width: 37.5em) {
  .aspect-ratio-box[class*=to-standard-from-md] {
    padding-bottom: 75%;
  }
  .aspect-ratio-box[class*=to-square-from-md] {
    padding-bottom: 100%;
  }
  .aspect-ratio-box[class*=to-wide-from-md] {
    padding-bottom: 56.25%;
  }
  .aspect-ratio-box[class*=to-portrait-from-md] {
    padding-bottom: 133.3333333333%;
  }
  .aspect-ratio-box[class*=to-semiportrait-from-md] {
    padding-bottom: 116.6666666667%;
  }
}
@media (min-width: 56.25em) {
  .aspect-ratio-box[class*=to-standard-from-lg] {
    padding-bottom: 75%;
  }
  .aspect-ratio-box[class*=to-square-from-lg] {
    padding-bottom: 100%;
  }
  .aspect-ratio-box[class*=to-wide-from-lg] {
    padding-bottom: 56.25%;
  }
  .aspect-ratio-box[class*=to-portrait-from-lg] {
    padding-bottom: 133.3333333333%;
  }
  .aspect-ratio-box[class*=to-semiportrait-from-lg] {
    padding-bottom: 116.6666666667%;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/aspect-ratio-box/dist/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;AACF","sourcesContent":[".aspect-ratio-box {\n  width: 100%;\n  position: relative;\n  height: auto;\n  display: block;\n  padding-bottom: 75%;\n  box-sizing: border-box;\n}\n.aspect-ratio-box[class*=\"--standard\"] {\n  padding-bottom: 75%;\n}\n.aspect-ratio-box[class*=\"--square\"] {\n  padding-bottom: 100%;\n}\n.aspect-ratio-box[class*=\"--wide\"] {\n  padding-bottom: 56.25%;\n}\n.aspect-ratio-box[class*=\"--portrait\"] {\n  padding-bottom: 133.3333333333%;\n}\n.aspect-ratio-box[class*=\"--semiportrait\"] {\n  padding-bottom: 116.6666666667%;\n}\n.aspect-ratio-box .image {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: transparent;\n  padding: 0;\n}\n\n@media (min-width: 37.5em) {\n  .aspect-ratio-box[class*=to-standard-from-md] {\n    padding-bottom: 75%;\n  }\n  .aspect-ratio-box[class*=to-square-from-md] {\n    padding-bottom: 100%;\n  }\n  .aspect-ratio-box[class*=to-wide-from-md] {\n    padding-bottom: 56.25%;\n  }\n  .aspect-ratio-box[class*=to-portrait-from-md] {\n    padding-bottom: 133.3333333333%;\n  }\n  .aspect-ratio-box[class*=to-semiportrait-from-md] {\n    padding-bottom: 116.6666666667%;\n  }\n}\n@media (min-width: 56.25em) {\n  .aspect-ratio-box[class*=to-standard-from-lg] {\n    padding-bottom: 75%;\n  }\n  .aspect-ratio-box[class*=to-square-from-lg] {\n    padding-bottom: 100%;\n  }\n  .aspect-ratio-box[class*=to-wide-from-lg] {\n    padding-bottom: 56.25%;\n  }\n  .aspect-ratio-box[class*=to-portrait-from-lg] {\n    padding-bottom: 133.3333333333%;\n  }\n  .aspect-ratio-box[class*=to-semiportrait-from-lg] {\n    padding-bottom: 116.6666666667%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
